import { Paper, Skeleton, Grid, Stack } from "@mui/material";
import RoundedBox from "../../Basics/RoundedBox";

export default function PayPlanHistoryAssignmentsLoader() {
	const amount = 10;
	return (
		<Paper elevation={0} className="section">
			<Grid container direction="column">
				<RoundedBox sx={{ minHeight: "250px" }}>
					<Grid container display={"flex"} direction="column" item sx={{ marginTop: "5px", marginLeft: "10px" }}>
						<Skeleton
							sx={{
								borderRadius: "3px",
							}}
							animation="wave"
							variant="rectangular"
							width={250}
							height={25}
						/>

						<Grid container display={"flex"} direction={"row"} gap={10} alignItems={"center"} mt={4}>
							<Grid>
								<Grid sx={{ display: "flex", columnGap: 0.8, alignItems: "center" }}>
									<Skeleton
										sx={{
											borderRadius: "3px",
										}}
										animation="wave"
										variant="rectangular"
										width={250}
										height={12}
									/>
								</Grid>
								<Grid sx={{ display: "flex", columnGap: 0.8, alignItems: "center" }}>
									<Skeleton
										sx={{
											borderRadius: "3px",
											marginTop: "8px",
										}}
										animation="wave"
										variant="rectangular"
										width={250}
										height={12}
									/>
								</Grid>
							</Grid>

							<Grid>
								<Grid sx={{ display: "flex", columnGap: 0.8, alignItems: "center" }}>
									<Skeleton
										sx={{
											borderRadius: "3px",
										}}
										animation="wave"
										variant="rectangular"
										width={250}
										height={12}
									/>
								</Grid>
								<Grid sx={{ display: "flex", columnGap: 0.8, alignItems: "center" }}>
									<Skeleton
										sx={{
											borderRadius: "3px",
											marginTop: "8px",
										}}
										animation="wave"
										variant="rectangular"
										width={250}
										height={12}
									/>
								</Grid>
							</Grid>
						</Grid>
						<Skeleton
							sx={{
								borderRadius: "3px",
								marginTop: "50px",
							}}
							animation="wave"
							variant="rectangular"
							width={250}
							height={12}
						/>
						<Skeleton
							sx={{
								borderRadius: "3px",
								marginTop: "20px",
								marginRight: "100px",
							}}
							animation="wave"
							variant="text"
							width={"auto"}
							height={12}
						/>
						<Skeleton
							sx={{
								borderRadius: "3px",
								marginRight: "100px",
							}}
							animation="wave"
							variant="text"
							width={"auto"}
							height={12}
						/>
						<Skeleton
							sx={{
								borderRadius: "3px",
								marginRight: "100px",
							}}
							animation="wave"
							variant="text"
							width={"auto"}
							height={12}
						/>
						<Skeleton
							sx={{
								borderRadius: "3px",
								marginRight: "100px",
							}}
							animation="wave"
							variant="text"
							width={"auto"}
							height={12}
						/>
					</Grid>
				</RoundedBox>
			</Grid>
			<RoundedBox sx={{ marginTop: "20px", minHeight: "250px" }}>
				<Grid
					container
					sx={{
						columnGap: 0,
						alignItems: "top",
						marginTop: "10px",
						marginLeft: "10px",
						marginRight: "32px",
					}}
				>
					<Grid item xs={4}>
						<Grid direction="row" display={"flex"}>
							<Grid direction="column" display={"flex"} className="overflow-auto h-80">
								<Skeleton animation="wave" variant="circular" width={12} height={12} />
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "4px",
										marginBottom: "4px",
										marginLeft: "4px",
									}}
									animation="wave"
									variant="rectangular"
									width={3}
									height={50}
								/>
								<Skeleton animation="wave" variant="circular" width={12} height={12} />
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "4px",
										marginBottom: "4px",
										marginLeft: "4px",
									}}
									animation="wave"
									variant="rectangular"
									width={3}
									height={50}
								/>
								<Skeleton animation="wave" variant="circular" width={12} height={12} />
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "4px",
										marginBottom: "4px",
										marginLeft: "4px",
									}}
									animation="wave"
									variant="rectangular"
									width={3}
									height={50}
								/>
								<Skeleton animation="wave" variant="circular" width={12} height={12} />
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "4px",
										marginBottom: "4px",
										marginLeft: "4px",
									}}
									animation="wave"
									variant="rectangular"
									width={3}
									height={50}
								/>
								<Skeleton animation="wave" variant="circular" width={12} height={12} />
							</Grid>
							<Grid direction="column" className="ml-4">
								<Skeleton
									sx={{
										borderRadius: "3px",
									}}
									animation="wave"
									variant="rectangular"
									width={"auto"}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "5px",
									}}
									animation="wave"
									variant="rectangular"
									width={150}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "45px",
									}}
									animation="wave"
									variant="rectangular"
									width={200}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "5px",
									}}
									animation="wave"
									variant="rectangular"
									width={150}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "45px",
									}}
									animation="wave"
									variant="rectangular"
									width={200}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "5px",
									}}
									animation="wave"
									variant="rectangular"
									width={150}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "45px",
									}}
									animation="wave"
									variant="rectangular"
									width={200}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "5px",
									}}
									animation="wave"
									variant="rectangular"
									width={150}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "45px",
									}}
									animation="wave"
									variant="rectangular"
									width={200}
									height={10}
								/>
								<Skeleton
									sx={{
										borderRadius: "3px",
										marginTop: "5px",
									}}
									animation="wave"
									variant="rectangular"
									width={150}
									height={10}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={8} container spacing={1}>
						{Array(amount)
							.fill(amount)
							.map((_e, i) => {
								const itemKey = `item-${i}`;
								return (
									<Grid direction={"column"} key={itemKey} xs={4} item>
										<Paper className="!shadow-md">
											<Stack direction={"column"} display={"flex"} justifyContent={"space-between"}>
												<Stack
													direction="row"
													spacing={2}
													alignItems={"center"}
													className={"ml-3 mt-3 mr-3 mb-3 w-56"}
												>
													<Skeleton animation="wave" variant="circular" width={32} height={32} />
													<Stack direction={"column"}>
														<Skeleton animation="wave" variant="text" width={120} height={12} />
														<Skeleton animation="wave" variant="text" width={80} height={12} />
													</Stack>
												</Stack>
											</Stack>
										</Paper>
									</Grid>
								);
							})}
					</Grid>
				</Grid>
			</RoundedBox>
		</Paper>
	);
}
